import { Typography } from "@material-ui/core";
import { forwardRef, Ref } from "react";

export const Empty = forwardRef((props: any, ref: Ref<HTMLDivElement>) => {
  return (
    <div ref={ref} {...props}>
      <Typography variant="body1">No data to display</Typography>
    </div>
  );
});
